import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard } from '../../Components/Common/DashboardKit';
import 'react-toastify/dist/ReactToastify.css';

/**
 * Shipping module landing page.
 *
 * UI-only refactor (Pass 1):
 *  - Swapped the legacy <BreadCrumb> for the standard
 *    <DashboardPageHeader>.
 *  - Replaced the video-based <ComingSoon> with <ComingSoonCard>.
 *
 * Route is wrapped in <RoleProtected requireManager> in allRoutes.js;
 * unchanged. Dead imports removed (api, DigitalClock, react-toastify,
 * etc.) — none were referenced in the markup.
 */
const Shipping = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-truck-line"
                        eyebrow="Logistics"
                        title="Shipping"
                        subtitle="Outbound shipments, packing, and carrier tracking"
                        tone="blue"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Shipping" },
                        ]}
                    />

                    <ComingSoonCard
                        icon="ri-truck-line"
                        title="Shipping workspace is coming soon"
                        message="The shipping workspace is being built out. Outbound shipment tracking, packing slips, and carrier integration will land here."
                        tone="info"
                        features={[
                            "Daily outbound shipment list",
                            "Packing slip generation",
                            "Carrier tracking lookups",
                            "Customer delivery confirmations",
                        ]}
                        contact="Reach out to the Shipping team for ETA updates."
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Shipping;
